import React from 'react';

const SourceLink = props => {
  return (
    <a
      href={process.env.REACT_APP_SOURCE_URL}
      target="https://darengot.netlify.app/"
      rel="noopener noreferrer"
      {...props}
    />
  );
};

export default SourceLink;
